import { render } from "./SidebarCategory.vue?vue&type=template&id=857a50e6"
import script from "./SidebarCategory.vue?vue&type=script&lang=js"
export * from "./SidebarCategory.vue?vue&type=script&lang=js"
script.render = render

export default script